export const fileExtentions = [
  '.docx',
  '.pdf',
  '.xlsx',
  '.png',
  '.jpeg',
  '.jpg',
  '.eml',
  '.msg',
  '.tiff',
  '.bmp',
  '.txt'
];

export const fileAcceptString = fileExtentions.join(',');

const fileExtentionRegEx = new RegExp("\\" + fileExtentions.join('$|\\') + "$", "i");

export const validateFileExtensions = (fileNames?: string[]) => {
  if (fileNames) {
    return fileNames.filter(f => fileExtentionRegEx.test(f)).length == fileNames.length
  }
  else {
    return true;
  }
}

export const yupFileTestOptions = {
  message: `Only the following file extentions are supported: ${fileExtentions.map(r => r.substring(1)).join(', ')}.`,
  test: validateFileExtensions
}
